import { AfterViewInit, Directive, ElementRef, Inject, DOCUMENT } from '@angular/core'


@Directive({
    selector: '[app-dynamic-script]',
    standalone: true
})
export class DynamicScriptDirective implements AfterViewInit {
   constructor(
      private el: ElementRef,
      @Inject(DOCUMENT) private document: Document) { }
   ngAfterViewInit() {
      const templateEl = this.el.nativeElement.firstElementChild as HTMLElement
      if (templateEl) {
         this._replaceDivWithScript(templateEl)
      }
   }

   private _replaceDivWithScript(templateEl: HTMLElement) {
      const script = this.document.createElement('script')

      this._copyAttributesFromTemplateToScript(templateEl, script)
      this._copyTemplateContentToScript(templateEl, script)

      templateEl.remove()

      // add the new script element to the host div so the browser will execute it
      this.el.nativeElement.appendChild(script)
   }

   private _copyAttributesFromTemplateToScript(templateEl: HTMLElement, script: HTMLScriptElement) {
      for (let a = 0; a < templateEl.attributes.length; a++) {
         script.attributes.setNamedItem(templateEl.attributes[a].cloneNode() as Attr)
      }
   }

   private _copyTemplateContentToScript(templateEl: HTMLElement, script: HTMLScriptElement) {
      const scriptContent = this.document.createTextNode(templateEl.textContent)
      script.appendChild(scriptContent)
   }

   /*
   EXAMPLE USAGE:
      //https://medium.com/ngconf/dynamically-execute-script-in-an-angular-component-e4dbcf9a34

      <div app-dynamic-script>
         <!-- most tags work, but Angular strips script tags, so don't try it. -->
         <div
            src="http://some.script.com/thing.js"
            my-custom-attr="some value">
            Some Text
         </div>
      </div>
   */
}
